export default __webpack_public_path__ + "e160c0b9a3710bb40e4f2342fdc5c36a.ttf";